import React, { Suspense } from "react";
import Avatar from "@material-ui/core/Avatar";
import { connect } from "react-redux";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { userSignOut } from "actions/Auth";
import IntlMessages from "util/IntlMessages";
import Paper from "@material-ui/core/Paper";
import "../../admin/routes/setup/programme/table.css";
import { NotificationManager } from "react-notifications";
import { fetchJSON } from "helpers/axios";
import { IconButton } from "@material-ui/core";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import Toolbar from "@material-ui/core/Toolbar";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { CircularProgress } from "@material-ui/core";
import LuminateLogo from "assets/images/logo.png";
import { Redirect } from "react-router-dom";

import GenericPdfDownloader from "../../applicant/routes/dashboard/downloadPDF";

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

function TabContainer({ children, dir }) {
  return (
    <div dir={dir} style={{ padding: 8 * 3 }}>
      {children}
    </div>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};

class UserInfo extends React.Component {
  state = {
    anchorEl: null,
    open: false,
    passport: "",
    passportData: "data:image/jpeg;base64,",
    applicant: this.props.authUser,
    olevel: [],
    applicationFormDrawer: false,
  };


  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open,
    });
  };

  handleClick = (event) => {
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  handleRequestClose = () => {
    this.setState({ open: false });
  };

  makeShiftLogOut = async () => {
    localStorage.removeItem("http://localhost:state");
    return setTimeout(() => {
      location.href = "http://localhost:3000/portal/alumni";
      // location.href = "https://umcatc-portal-dev.azurewebsites.net/portal/";
      location.reload();
    }, 2000);
  };

  getPassport = () => {
    if (this.props.userMode === "Admin") {
      if (this.props?.user?.Passport == null) {
        return this.props?.user?.LastName.charAt(0);
      }
    } else {
      if (this.props?.user?.Passport == null) {
        return (
          this.props?.user?.LastName.charAt(0) +
          this.props?.user?.FirstName.charAt(0)
        );
      }
    }
  };

  showPassport = () => {
    if (this.props.userMode === "Admin") {
      return this.props?.user?.Passport;
    } else {
      if (this.props.userMode === "student") {
        return `${this.props?.user?.Passport}`;
        // return `data:image/jpg;base64, ${this.props?.user?.Passport}`;
      } else {
        return `${this.props?.user?.Passport}`;
        // return `data:image/jpg;base64, ${this.props?.user?.Passport}`;
      }
    }
  };

  async componentDidMount() {
    try {
      console.log(this.props)

      const { userMode } = this.props;
      if (userMode == "Applicant") {
        this.applicantOlevel();
      }
    } catch (error) {
      NotificationManager.error("An error occurred.");
      console.log("e", error);
    }
  }
  // This function is to get and set the applicant Olevel data
  applicantOlevel = async () => {
    try {
      const { token, ApplicantID } = this.props.authUser;
      const response = await fetchJSON(
        `api/OResults/NewhasOlevelResult?applicantId=${ApplicantID}`,
        null,
        "GET",
        token
      );
      if (response.Status === "Ok") {
        this.setState({
          olevel: response.Data,
        });
      } else {
        NotificationManager.error(response.Message);
      }
    } catch (error) {
      NotificationManager.error("An error occurred.");
    }
  };

  // This function is used to display the appliant form for usermode of applicant
  ApplicantForm = () => {
    const { applicant, olevel } = this.state;
    // Function to handle DOB value
    const handleDobValue = (DateOfBirth) => {
      const myDate = new Date(DateOfBirth);
      const dayOfMonth = myDate.getDate();
      const month = myDate.getMonth();
      const year = myDate.getFullYear();
      if (myDate !== "") {
        return year + "-" + pad(month + 1) + "-" + pad(dayOfMonth);
      }
    };

    const pad = (n) => {
      return n < 10 ? "0" + n : n;
    };
    return (
      <>
        <Paper>
          {/* style={{ display: 'none' }} */}
          <div id="con">
            <header className="mt-2" style={{ borderBottom: "1px solid gray" }}>
              <div className="container">
                <div className="row">
                  <div className="col-lg-3">
                    <img
                      className="img-fluid"
                      // src="https://odfelbidadoc01.blob.core.windows.net/passport/46bf7d16-aeae-4e96-b80b-1966795887c0.png"
                      src={LuminateLogo}
                      alt=""
                      style={{ maxWidth: "100px", maxHeight: "100px" }}
                    />
                  </div>
                  <div className="col-lg-9 flex-column align-self-end">
                    <h1 style={{ color: "#540000", fontSize: "40px" }}>
                      <strong>UMCA Theological College</strong>
                    </h1>
                  </div>
                </div>
              </div>
            </header>

            {/* Details Section */}
            <div className="container-fluid mb-5">
              <div className="row mx-5 d-flex flex-sm-row-reverse flex-lg-row">
                <div className="col-lg-8 mt-3">
                  <div className="col-lg-12 text-center mb-3">
                    <h3
                      className="p-3"
                      style={{
                        fontSize: "2.5em",
                        fontWeight: "bold",
                        borderRadius: "6px",
                      }}
                    >
                      APPLICATION FORM
                    </h3>
                  </div>
                  <div className="row mb-4">
                    <div className="col-lg-6">
                      <h3
                        className="p-2 text-center"
                        style={{
                          fontSize: "1.5em",
                          fontWeight: "bold",
                          borderRadius: "6px",
                          backgroundColor: "#540000",
                          color: "white",
                        }}
                      >
                        BASIC DETAILS
                      </h3>
                    </div>
                    <div className="col-lg-6"></div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 col-lg-6">
                      <p className="mb-1 mt-3 font-weight-bold">
                        Application Number
                      </p>
                      {applicant.ApplicantNumber}
                    </div>
                    <div className="col-md-6 col-lg-6">
                      <p className="mb-1 mt-3 font-weight-bold">
                        Admission Level
                      </p>
                      {applicant.Applicant.LevelName}
                    </div>
                    <div className="col-md-6 col-lg-6">
                      <p className="mb-1 mt-3 font-weight-bold">
                        Program Category
                      </p>
                      {applicant.Applicant.CategoryName}
                    </div>
                    <div className="col-md-6 col-lg-6">
                      <p className="mb-1 mt-3 font-weight-bold">Program</p>
                      {applicant.Applicant.DepartmentName}
                    </div>
                  </div>
                  <hr />
                </div>
                <div className="col-lg-4">
                  <p className="mb-1 mt-3 font-weight-bold">Passport</p>
                  <img
                    className="img-fluid offset-2 border"
                    src={
                      applicant.Passport != null
                        ? applicant.Passport
                        : "https://res.cloudinary.com/ebenofere/image/upload/v1624623119/passport_eb9mhb.jpg"
                    }
                    alt=""
                    style={{ maxWidth: "200px", maxHeight: "200px" }}
                  />
                </div>
              </div>

              <div className="row mx-5">
                <div className="col-md-6  col-lg-4 border-bottom ">
                  <p className="mb-1 mt-3 font-weight-bold">First Name</p>
                  {applicant.FirstName}
                </div>
                <div className="col-md-6 col-lg-4 border-bottom ">
                  <p className="mb-1 mt-3 font-weight-bold">Other Name</p>
                  {applicant.OtherName}
                </div>
                <div className="col-md-6 col-lg-4 border-bottom ">
                  <p className="mb-1 mt-3 font-weight-bold">Last Name</p>
                  {applicant.LastName}
                </div>
                <div className="col-md-6 col-lg-4 border-bottom ">
                  <p className="mb-1 mt-3 font-weight-bold">Email</p>
                  {applicant.Email}
                </div>
                <div className="col-md-6 col-lg-4 border-bottom ">
                  <p className="mb-1 mt-3 font-weight-bold">Date of Birth</p>
                  {handleDobValue(applicant.DateOfBirth)}
                </div>
                <div className="col-md-6 col-lg-4 border-bottom ">
                  <p className="mb-1 mt-3 font-weight-bold">Gender</p>
                  {applicant.Gender}
                </div>
                <div className="col-md-6 col-lg-4 border-bottom ">
                  <p className="mb-1 mt-3 font-weight-bold">Phone Number</p>
                  {applicant.PhoneNumber}
                </div>
                <div className="col-md-6 col-lg-4 border-bottom ">
                  <p className="mb-1 mt-3 font-weight-bold">Marital Status</p>
                  {applicant.Applicant.MaritalStatusName}
                </div>
                <div className="col-md-6 col-lg-4 border-bottom ">
                  <p className="mb-1 mt-3 font-weight-bold">Address</p>
                  {applicant.Address}
                </div>
                <div className="col-md-6 col-lg-4 border-bottom ">
                  <p className="mb-1 mt-3 font-weight-bold">Country</p>
                  {applicant.Applicant.CountryName}
                </div>
                <div className="col-md-6 col-lg-4 border-bottom ">
                  <p className="mb-1 mt-3 font-weight-bold">State</p>
                  {applicant.Applicant.StateName}
                </div>
                <div className="col-md-6 col-lg-4 border-bottom ">
                  <p className="mb-1 mt-3 font-weight-bold">LGA</p>
                  {applicant.Applicant.LGAName}
                </div>
              </div>
            </div>

            {/* Olevel Section */}
            <div className="container-fluid pt-2 mb-5">
              <div className="row mx-5">
                <div className="col">
                  <div className="row">
                    <div className="col-lg-4">
                      <h3
                        className="p-2 text-center"
                        style={{
                          fontSize: "1.5em",
                          fontWeight: "bold",
                          borderRadius: "6px",
                          backgroundColor: "#540000",
                          color: "white",
                        }}
                      >
                        APPLICANT O'LEVEL
                      </h3>
                    </div>
                  </div>

                  <table id="documents" className="border">
                    <thead>
                      <tr>
                        <th>Type</th>
                        <th>Subject</th>
                        <th>Grade</th>
                      </tr>
                    </thead>
                    <tbody>
                      {olevel
                        ? olevel.map((o, i) => (
                            <tr key={i}>
                              <td>{o.OLevelTypeName}</td>
                              <td>{o.OLevelSubjectName}</td>
                              <td>{o.GradeName}</td>
                            </tr>
                          ))
                        : ""}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </Paper>
      </>
    );
  };

  render() {
    const { userMode, authUser } = this.props;
    const ApplicantForm = this.ApplicantForm;
    const { applicationFormDrawer } = this.state;
    return (
      <div
        className="user-profile d-flex flex-row align-items-center"
        style={{ margin: "-15px 20px" }}
      >
        {this.props?.user?.Passport === null ? (
          <Avatar className="bg-primary size-50 text-white">
            {this.getPassport()}
          </Avatar>
        ) : (
          <Avatar
            alt={this.getPassport()}
            src={this.showPassport()}
            className="user-avatar img-rounded"
          />
        )}

        <div
          className="user-detail"
          style={{ marginTop: "25px", marginLeft: "0px" }}
        >
          <h2 className="user-name" onClick={this.handleClick}>
            {`${this.props?.user?.LastName} ${this.props?.user?.FirstName}`}
            <i className="zmdi zmdi-caret-down zmdi-hc-fw align-middle" />
          </h2>
          <p>
            {/* {this.props?.user?.RoleName == undefined
              ? (userMode == "Staff"
                ? "Global Admin"
                : (userMode == "Student"
                ? "Student"
                : (authUser.AdmModeId === 1
                ? "Applicant - HND"
                : "Applicant - ND")))
              : this.props?.user?.RoleName} */}
          </p>
        </div>
        <Menu
          className="user-info"
          id="simple-menu"
          anchorEl={this.state.anchorEl}
          open={this.state.open}
          onClose={this.handleRequestClose}
          PaperProps={{
            style: {
              minWidth: 120,
              paddingTop: 0,
              paddingBottom: 0,
            },
          }}
        >
          {userMode == "Admin" ? (
            <MenuItem
              onClick={() => {
                window.location.replace("/portal/admin/profile");
              }}
            >
              <i className="zmdi zmdi-account zmdi-hc-fw mr-2" />
              <IntlMessages id="popup.profile" />
            </MenuItem>
          ) : userMode == "Applicant" ? (
            <MenuItem
              onClick={() => {
                this.setState({ applicationFormDrawer: true });
              }}
            >
              <i className="zmdi zmdi-account zmdi-hc-fw mr-2" />
              Applicant Form
            </MenuItem>
          ) : userMode == "Student" ? (
            <MenuItem
              onClick={() => {
                window.location.replace("/portal/student/profile");
              }}
            >
              <i className="zmdi zmdi-account zmdi-hc-fw mr-2" />
              <IntlMessages id="popup.profile" />
            </MenuItem>
          ) : (
            ""
          )}

          {/* <MenuItem onClick={() => {
            this.handleRequestClose();
          }}>
            <Icon path={mdiLockReset}
                  title="Change Password"
                  size={.6}
            />
            <Link to="/app/changepassword" className="ml-2 text-dark"> Change Password</Link>
          </MenuItem> */}
          {/* <MenuItem onClick={this.handleRequestClose}>
            <i className="zmdi zmdi-settings zmdi-hc-fw mr-2"/>
            <IntlMessages id="popup.setting"/>
          </MenuItem> */}
          <MenuItem
            onClick={() => {
              this.handleRequestClose();
              this.props.userMode === 'Alumni' ? this.makeShiftLogOut() :
              this.props.userSignOut(this.props?.user?.sid, this.props.userMode);
            }}
          >
            <i className="zmdi zmdi-sign-in zmdi-hc-fw mr-2" />

            <IntlMessages id="popup.logout" />
          </MenuItem>
        </Menu>

        {/*================= Application Form */}
        <Dialog
          fullScreen
          open={applicationFormDrawer}
          onClose={this.toggleDrawer("applicationFormDrawer", false)}
          TransitionComponent={Transition}
        >
          <AppBar
            className="position-relative"
            style={{ backgroundColor: "#540000" }}
          >
            <Toolbar>
              <IconButton
                style={{ color: "white" }}
                onClick={this.toggleDrawer("applicationFormDrawer", false)}
                aria-label="Close"
              >
                <CloseIcon />
              </IconButton>
              <Typography
                variant="h5"
                style={{
                  flex: 1,
                  color: "white",
                }}
              >
                Applicant Details
              </Typography>
              <GenericPdfDownloader
                downloadFileName="ApplicantFormPDF"
                rootElementId="con"
              />
            </Toolbar>
          </AppBar>
          <Suspense
            fallback={
              <div
                className="loader-view"
                // style={{
                //   height:
                //     width >= 1200
                //       ? 'calc(100vh - 265px)'
                //       : 'calc(100vh - 245px)',
                // }}
              >
                <CircularProgress />
              </div>
            }
          >
            <ApplicantForm />
          </Suspense>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = ({ settings, auth }) => {
  const { locale } = settings;
  const authUser = auth.applicantUser;
  return { locale, authUser };
};
export default connect(mapStateToProps, { userSignOut })(UserInfo);
